"use strict";
import React, { createContext, useContext, useMemo } from "react";
import { FeatureFlags } from "features/gating/flags";
import { useFeatureFlag } from "features/gating/hooks";
import { MismatchAccountEffects } from "features/smartWallet/mismatch/MismatchAccountEffects";
import { useEvent } from "utilities/src/react/hooks";
const MismatchContext = createContext(void 0);
export const MismatchContextProvider = React.memo(function MismatchContextProvider2({
  children,
  mismatchCallback: mismatchCallbackProp,
  address,
  chainId,
  onHasAnyMismatch,
  chains,
  defaultChainId,
  isTestnetModeEnabled
}) {
  const isMismatchForced = useIsMismatchForced();
  const mismatchCallback = useEvent(async (input) => {
    if (isMismatchForced) {
      return true;
    }
    return mismatchCallbackProp(input);
  });
  const value = useMemo(
    () => ({
      mismatchCallback,
      account: { address, chainId },
      onHasAnyMismatch,
      chains,
      defaultChainId,
      isTestnetModeEnabled
    }),
    [mismatchCallback, address, chainId, onHasAnyMismatch, chains, defaultChainId, isTestnetModeEnabled]
  );
  return <MismatchContext.Provider value={value}>
      {
    /* handle our effects here */
  }
      <MismatchAccountEffects />
      {children}
    </MismatchContext.Provider>;
});
MismatchContextProvider.displayName = "MismatchContextProvider";
export function useMismatchContext() {
  const value = useContext(MismatchContext);
  if (!value) {
    throw new Error("MismatchContext not found");
  }
  return value;
}
function useIsMismatchForced() {
  return useFeatureFlag(FeatureFlags.ForcePermitTransactions);
}
